import React from 'react'

import { getDiscHex, getSVGClasses } from '@dashboard/lib/svg'

interface OwnProps {
  discType?: string
  color?: string
}

export default class PlaybookLionSVG extends React.Component<OwnProps> {
  render() {
    const { discType, color } = this.props
    const { a, b, c } = getSVGClasses('renderPlaybookLion', discType, color)

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 85.615 101.534"
      >
        <defs>
          <style>{`.${a}{fill:none;stroke:${getDiscHex(
            discType,
            color,
          )};stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.${b}{opacity:0.1;}.${c}{fill:${getDiscHex(
            discType,
            color,
          )};}`}</style>
        </defs>
        <g transform="translate(-1584.034 -994.764)">
          <g transform="translate(69.619 380.926)">
            <path
              className={a}
              d="M1593.249,649.89c2.634,6.482,5.627,16.618,5.775,24.166.108,5.479-.831,10.608-1.826,16.039-.167.908-.334,1.829-.5,2.756q-.415-.744-.833-1.485-.765-1.365-1.526-2.73a1.805,1.805,0,0,0-3.289.3c-.023.07-2.339,6.982-3.375,9.123-.682,1.433-2.573,4.46-4,6.683l-3.522-7.207a1.8,1.8,0,0,0-3.2-.089l-6.166,11.006-3.9-3.557a1.806,1.806,0,0,0-2.635.219l-7.276,9.254-6.817-9.212a1.8,1.8,0,0,0-2.664-.262l-3.915,3.561-6.168-11.009a1.838,1.838,0,0,0-1.625-.923,1.806,1.806,0,0,0-1.571,1.012l-3.284,6.721c-.451-.6-.969-1.236-1.534-1.923-.346-.417-.775-.938-.879-1.1a53.143,53.143,0,0,1-5.185-12.179,1.8,1.8,0,0,0-3.3-.32l-2.5,4.574c-.147-.417-.3-.851-.329-.992-.477-2.087-.864-4.222-1.15-6.346a71.827,71.827,0,0,1-.589-12.415c.307-7.76,3.184-18.019,5.659-24.131"
            />
            <path
              className={a}
              d="M1525.735,653.81a1.808,1.808,0,0,0-1.059-2.323,8.675,8.675,0,0,1-4.7-4.054,6.64,6.64,0,0,1-.426-5.456c1.289-3.443,5.454-5.209,9.485-4.016.948.282-8.377-6.907-8.377-6.907,1.494-.6,3.159-1.239,4.037-1.52,1.994-.658,8.245-2.044,8.306-2.059a1.8,1.8,0,0,0,.969-2.948l-4.248-4.865a32.64,32.64,0,0,1,4.44.145c2.947.291,6.041,1.841,7.889,2.766a12.065,12.065,0,0,0,2.039.9,1.942,1.942,0,0,0,1.936-.577c.592-.655,1.2-1.329-1.089-8.056a13.886,13.886,0,0,1,6.974,2.933,25.346,25.346,0,0,1,2.031,1.933,4.43,4.43,0,0,0,3.191,1.366h0a4.43,4.43,0,0,0,3.193-1.368,24.483,24.483,0,0,1,2.03-1.931,13.886,13.886,0,0,1,6.975-2.933c-2.289,6.727-1.681,7.4-1.09,8.056a1.953,1.953,0,0,0,1.949.573,12,12,0,0,0,2.026-.894c1.848-.925,4.942-2.475,7.891-2.766a32.505,32.505,0,0,1,4.439-.145l-4.249,4.865a1.8,1.8,0,0,0,.97,2.948c.062.015,6.31,1.4,8.321,2.062.871.279,2.531.923,4.023,1.517,0,0-9.113,7.19-8.168,6.907a8.832,8.832,0,0,1,3.832-.272,1.791,1.791,0,0,0,.4.074,6.911,6.911,0,0,1,5.254,4.214,6.635,6.635,0,0,1-.426,5.456,8.677,8.677,0,0,1-4.7,4.054,1.8,1.8,0,0,0-1.058,2.322"
            />
            <path className={a} d="M1575.547,678.441" />
            <path className={a} d="M1557.369,645.949" />
            <path
              className={a}
              d="M1555.531,644.836s-14.963-10.512-19.586,6.248c-1.409,5.107-5.374,18.608,7.717,26.694"
            />
            <path
              className={a}
              d="M1556.861,644.836s14.963-10.512,19.586,6.248c1.409,5.107,5.164,18.657-7.95,27.077"
            />
            <line
              className={a}
              y1="7.244"
              transform="translate(1556.22 645.362)"
            />
            <line
              className={a}
              y2="5.408"
              transform="translate(1556.22 656.59)"
            />
            <path
              className={a}
              d="M1526.584,647.627a3.076,3.076,0,1,1,3.093-5.245"
            />
            <path
              className={a}
              d="M1588.389,647.627a3.076,3.076,0,1,0-3.093-5.245"
            />
            <path className={a} d="M1559.633,680.532l-4.33,3.68-4.33-3.68Z" />
            <path
              className={a}
              d="M1550.232,656.6s-3.1,1.223-5.312-.055-2.705-4.574-2.705-4.574,3.1-1.222,5.313.056S1550.232,656.6,1550.232,656.6Z"
            />
            <path
              className={a}
              d="M1563.011,656.6s3.1,1.223,5.313-.055,2.7-4.574,2.7-4.574-3.1-1.222-5.313.056S1563.011,656.6,1563.011,656.6Z"
            />
            <path
              className={a}
              d="M1550.232,656.6s2.727,10.281-1.105,15.844c-3.051,4.429-11.545,12.3-3.627,17.023,5.7,3.395,10-3.08,10.047-5.256"
            />
            <path
              className={a}
              d="M1563.011,656.6s-4.029,10.281-.2,15.844c3.051,4.429,11.544,12.3,3.627,17.023-5.7,3.395-10-3.08-10.047-5.256"
            />
            <path
              className={a}
              d="M1546.45,690.434l-.956.828a.963.963,0,0,0-.1,1.412c1.488,1.663,5.415,5.456,10.272,5.456,5.005,0,9.372-3.54,11.055-5.1a.961.961,0,0,0,.034-1.429l-1.543-1.544"
            />
          </g>
          <g className={b} transform="translate(605.805 381.162)">
            <path className={c} d="M1019.083,685.212l6.33-5.68h-11.659Z" />
            <path
              className={c}
              d="M1011.307,652.028c-2.214-1.278-6.313-.056-6.313-.056s.491,4.3,2.7,5.574,6.313-.945,6.313-.945S1013.521,653.306,1011.307,652.028Z"
            />
            <path
              className={c}
              d="M1057.029,649.89l-.715-.005a8.285,8.285,0,0,0,1.968-2.452,6.64,6.64,0,0,0,.426-5.456,6.913,6.913,0,0,0-5.255-4.214,1.8,1.8,0,0,1-.4-.074,8.827,8.827,0,0,0-3.831.272c-.946.283,8.167-6.907,8.167-6.907-1.491-.594-3.151-1.238-4.022-1.517-2.011-.661-8.259-2.047-8.322-2.062a1.8,1.8,0,0,1-.969-2.948l4.249-4.865a32.507,32.507,0,0,0-4.439.145c-2.95.291-6.043,1.84-7.891,2.766a12.033,12.033,0,0,1-2.027.894,1.954,1.954,0,0,1-1.949-.573c-.59-.655-1.2-1.329,1.09-8.056a13.883,13.883,0,0,0-6.974,2.933,24.365,24.365,0,0,0-2.031,1.932,4.431,4.431,0,0,1-3.192,1.367h0a4.426,4.426,0,0,1-3.191-1.366,25.512,25.512,0,0,0-2.031-1.933,13.894,13.894,0,0,0-6.974-2.933c2.289,6.727,1.68,7.4,1.088,8.056a1.94,1.94,0,0,1-1.935.577,12.065,12.065,0,0,1-2.039-.9c-1.849-.926-4.943-2.475-7.89-2.766a32.635,32.635,0,0,0-4.44-.145l4.249,4.865a1.8,1.8,0,0,1-.969,2.948c-.062.015-6.312,1.4-8.307,2.059-.877.281-2.542.925-4.036,1.52,0,0,9.325,7.189,8.377,6.907-4.031-1.193-8.2.573-9.485,4.016a6.636,6.636,0,0,0,.426,5.456,8.189,8.189,0,0,0,1.477,1.994l-.322,0c-2.476,6.112-5.352,16.371-5.659,24.131a71.826,71.826,0,0,0,.588,12.415c.287,2.124.674,4.259,1.15,6.346.033.141.183.575.33.992l2.5-4.574a1.8,1.8,0,0,1,3.3.32,53.1,53.1,0,0,0,5.186,12.179c.1.165.533.686.878,1.1.565.687,1.084,1.324,1.535,1.923,1.431-2.93,3.284-6.721,3.284-6.721a1.806,1.806,0,0,1,1.571-1.012,1.84,1.84,0,0,1,1.625.923l6.167,11.009,3.916-3.561a1.8,1.8,0,0,1,2.664.262l6.817,9.212,7.276-9.254a1.805,1.805,0,0,1,2.634-.219l3.9,3.557,6.165-11.006a1.8,1.8,0,0,1,3.2.089l3.523,7.207c1.422-2.223,3.313-5.25,3.995-6.683,1.036-2.141,3.353-9.053,3.376-9.122a1.8,1.8,0,0,1,3.288-.3q.759,1.368,1.527,2.729c.278.5.555.99.832,1.486.165-.927.332-1.848.5-2.756.995-5.431,1.935-10.56,1.827-16.039C1062.656,666.508,1059.663,656.372,1057.029,649.89Zm-24.753,28.271-1.375-.021c2.7,3.906,4.441,8.277-.679,11.328a7.392,7.392,0,0,1-1.232.589l1.543,1.543a.961.961,0,0,1-.033,1.429c-1.683,1.561-6.051,5.1-11.055,5.1-4.858,0-8.784-3.793-10.272-5.457a.961.961,0,0,1,.1-1.411l.955-.828,1.716-.034a6.554,6.554,0,0,1-2.666-.932c-5.269-3.14-3.268-7.678-.442-11.668l-1.4-.022c-13.091-8.086-9.126-21.587-7.717-26.694,4.624-16.76,19.586-6.248,19.586-6.248h1.33s14.963-10.512,19.587,6.248C1041.635,656.191,1045.391,669.741,1032.276,678.161Z"
            />
            <path
              className={c}
              d="M1029.495,652.028c-2.214,1.278-3.7,4.573-3.7,4.573s5.1,2.223,7.313.945,1.7-5.574,1.7-5.574S1031.709,650.75,1029.495,652.028Z"
            />
          </g>
        </g>
      </svg>
    )
  }
}
